define(["require", "exports", "hypo_bvo/Drklein/Shared/OfficeAllocationService", "hypo_bvo/Drklein/Shared/AgentService"], function (require, exports, OfficeAllocationService_1, AgentService_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getOfficesPath = exports.getOffices = void 0;
    function buildOfficeQueryParams(searchParams) {
        var requiredTags = [];
        if (searchParams.agentWithLastName) {
            requiredTags.push('show_in_name_search');
        }
        else {
            requiredTags.push('show_in_zip_search');
        }
        searchParams.employeeTags = requiredTags;
        if (searchParams.latitude && searchParams.longitude) {
            searchParams.sort = 'distance';
        }
        searchParams.agentWithAllTagExternalKeys = requiredTags.join(",");
        if (searchParams.productGroups) {
            searchParams.agentWithAnyProductGroupPlatformId = searchParams.productGroups.join(",");
        }
        return searchParams;
    }
    /**
     * Returns the page of Offices and a transaction string that was initially passed to the function
     * @param searchParams
     */
    function getOffices(searchParams, transactionId) {
        var deferred = $.Deferred();
        $.get({
            url: getOfficesPath(),
            data: buildOfficeQueryParams(searchParams),
        }).then(function (officePageResource) {
            if (!officePageResource._embedded) {
                deferred.resolve({
                    offices: [],
                    page: officePageResource.page.number,
                    numberOfPages: officePageResource.page.totalPages,
                    transactionId: transactionId
                });
            }
            else {
                var officePage = {
                    offices: officePageResource._embedded.offices,
                    page: officePageResource.page.number,
                    numberOfPages: officePageResource.page.totalPages,
                    transactionId: transactionId
                };
                officePageResource._embedded.offices.forEach(function (office) {
                    office.agents = [];
                    office._embedded.officeAllocations.forEach(function (oa) {
                        if (oa._embedded.agent.employeeTags.includes('show_in_zip_search')
                            || (searchParams.agentWithLastName
                                && oa._embedded.agent.employeeTags.includes('show_in_name_search')
                                && oa._embedded.agent.lastName.toLowerCase().includes(searchParams.agentWithLastName.toLowerCase()))) {
                            var agent = (0, OfficeAllocationService_1.assembleAgentFromOfficeAllocation)(oa);
                            // @ts-ignore
                            office.agents.push(agent);
                        }
                    });
                });
                deferred.resolve(officePage);
            }
        })
            .fail(function () { return deferred.reject(); });
        return deferred.promise();
    }
    exports.getOffices = getOffices;
    function getOfficesPath() {
        return AgentService_1.PlatformCommunication.PLATFORM_PATH + "v2/bvo-offices";
    }
    exports.getOfficesPath = getOfficesPath;
});
